@if (!isOnboarding) {
    <header class="page-header">
        <div>
            <h1 class="page-header__title">{{ 'settings.title' | translate }}</h1>
        </div>
    </header>
}
<form [formGroup]="settingsForm" (ngSubmit)="onSubmit()">
    <div [class.card]="isOnboarding">
        @if (!isAdminForm || isOnboarding) {
            <h2 class="section-title">{{ 'components.settingsForm.companySection.title' | translate }}</h2>
            <div class="form-grid form-grid--2" [class.card]="!isOnboarding" formGroupName="organizationGroup">
                <div class="form-field form-field--wide">
                    <label for="companyLogoInput" class="form-field__label">
                        {{ 'components.settingsForm.companySection.companyLogo.label' | translate }}
                    </label>
                    <app-image-selector
                        inputId="companyLogoInput"
                        accept="image/png, image/jpeg"
                        [maxFileSize]="5 * 1024 * 1024"
                        [label]="'components.settingsForm.button.imageUpload' | translate"
                        formControlName="companyLogo"
                        styleClass="flex align-items-center"
                        [placeholder]="userClaim?.organization?.name?.substring(0, 2)"></app-image-selector>
                    <small class="form-field__help">
                        {{ 'components.settingsForm.companySection.companyLogo.accept' | translate }}
                    </small>
                    @if (
                        organizationFormGroup.get('companyLogo')?.invalid &&
                        organizationFormGroup.get('companyLogo')?.touched
                    ) {
                        @if (organizationFormGroup.get('companyLogo')?.errors?.invalidFileType) {
                            <small class="p-error">{{
                                'components.settingsForm.companySection.toasts.avatarUpload.invalideTypeFileError'
                                    | translate
                            }}</small>
                        }
                        @if (organizationFormGroup.get('companyLogo')?.errors?.fileSizeExceeded) {
                            <small class="p-error">{{
                                'components.settingsForm.companySection.toasts.avatarUpload.maxFileSizeError'
                                    | translate
                            }}</small>
                        }
                    }
                </div>
                <div class="form-field">
                    <label for="companyNameInput" class="form-field__label form-field__label--required">
                        {{ 'components.settingsForm.companySection.companyName.label' | translate }}
                    </label>
                    <input
                        id="companyNameInput"
                        pInputText
                        type="text"
                        formControlName="companyName"
                        [placeholder]="'components.settingsForm.companySection.companyName.placeholder' | translate" />
                    @if (
                        organizationFormGroup.get('companyName')?.errors?.required &&
                        organizationFormGroup.get('companyName')?.touched
                    ) {
                        <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
                    }
                </div>
                <div class="form-field">
                    <label for="countryInput" class="form-field__label form-field__label--required">
                        {{ 'components.settingsForm.entitySection.edit.country.label' | translate }}
                    </label>
                    <p-select
                        inputId="countryInput"
                        [options]="countries"
                        formControlName="country"
                        [placeholder]="'components.settingsForm.entitySection.edit.country.placeholder' | translate"
                        [filter]="true"
                        filterMatchMode="startsWith"
                        optionLabel="name"
                        optionValue="code"
                        [emptyFilterMessage]="'common.filter.empty' | translate"
                        [virtualScroll]="true"
                        [virtualScrollItemSize]="38"
                        (onBlur)="filterCities()"
                        (onChange)="onCountryChange($event)"
                        [filterPlaceholder]="'common.search' | translate">
                    </p-select>
                    @if (
                        organizationFormGroup.get('country')?.errors?.required &&
                        organizationFormGroup.get('country')?.touched
                    ) {
                        <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
                    }
                </div>
                <div class="form-field">
                    <label for="vatNumberInput" class="form-field__label">
                        {{ 'components.settingsForm.companySection.vatNumber.label' | translate }}
                        <span
                            class="material-symbols-outlined icon-sm align-middle cursor-help"
                            [pTooltip]="'components.settingsForm.companySection.vatNumber.infoType' | translate"
                            >info</span
                        >
                    </label>
                    <input
                        id="vatNumberInput"
                        pInputText
                        type="text"
                        formControlName="vatNumber"
                        [placeholder]="vatPlaceholder"
                        (blur)="onVatBlur()" />
                    @if (
                        organizationFormGroup.get('vatNumber')?.errors?.invalidVat &&
                        organizationFormGroup.get('vatNumber')?.touched
                    ) {
                        <small class="p-error">{{
                            'components.settingsForm.companySection.vatNumber.invalidVat'
                                | translate: { vatFormat: vatPlaceholder }
                        }}</small>
                    }
                </div>
                @if (false) {
                    <div class="form-field">
                        <label for="cityInput" class="form-field__label">
                            {{ 'components.settingsForm.entitySection.edit.city.label' | translate }}
                        </label>
                        <p-select
                            inputId="cityInput"
                            [options]="filteredCities"
                            formControlName="city"
                            [placeholder]="'components.settingsForm.entitySection.edit.city.placeholder' | translate"
                            [filter]="true"
                            filterMatchMode="startsWith"
                            optionLabel="name"
                            optionValue="id"
                            [emptyFilterMessage]="'common.filter.empty' | translate"
                            [virtualScroll]="true"
                            [virtualScrollItemSize]="38"
                            [filterPlaceholder]="'common.search' | translate">
                        </p-select>
                    </div>
                }
                <div class="form-field form-field--wide">
                    <label for="naceCodeInput" class="form-field__label form-field__label--required">
                        {{ 'components.settingsForm.companySection.naceCode.label' | translate }}
                    </label>
                    <p-select
                        inputId="naceCodeInput"
                        [options]="activities"
                        formControlName="naceCode"
                        [placeholder]="'components.settingsForm.companySection.naceCode.placeholder' | translate"
                        [showClear]="true"
                        [filter]="true"
                        filterBy="id,label"
                        [resetFilterOnHide]="true"
                        optionValue="id"
                        [emptyFilterMessage]="'common.filter.empty' | translate"
                        [virtualScroll]="true"
                        [virtualScrollItemSize]="38"
                        [filterPlaceholder]="'common.search' | translate">
                        <ng-template let-sa pTemplate="selectedItem">
                            <div class="truncate-text">{{ sa.id }} ({{ sa.label }})</div>
                        </ng-template>
                        <ng-template let-activity pTemplate="item">
                            <div>{{ activity.id }} ({{ activity.label }})</div>
                        </ng-template>
                    </p-select>
                    @if (
                        organizationFormGroup.get('naceCode')?.errors?.required &&
                        organizationFormGroup.get('naceCode')?.touched
                    ) {
                        <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
                    }
                </div>
                <div class="form-field">
                    <!-- Derived from the NACE code: shown, never edited. -->
                    <label for="industryCodeInput" class="form-field__label">
                        {{ 'components.settingsForm.companySection.industryCode.label' | translate }}
                    </label>
                    <input
                        id="industryCodeInput"
                        pInputText
                        type="text"
                        disabled
                        [value]="selectedIndustryActivity?.industrySectorLabel ?? ''"
                        [placeholder]="'components.settingsForm.companySection.industryCode.placeholder' | translate"
                        [pTooltip]="selectedIndustryActivity?.industrySectorLabel" />
                </div>
                <div class="form-field">
                    <label for="fteInput" class="form-field__label form-field__label--required">
                        {{ 'components.settingsForm.companySection.fte.label' | translate }}
                    </label>
                    <p-inputNumber
                        inputId="fteInput"
                        formControlName="fte"
                        [placeholder]="'components.settingsForm.companySection.fte.placeholder' | translate"
                        [min]="1"></p-inputNumber>
                    @if (organizationFormGroup.get('fte')?.invalid && organizationFormGroup.get('fte')?.touched) {
                        @if (organizationFormGroup.get('fte')?.errors?.required) {
                            <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
                        }
                        @if (organizationFormGroup.get('fte')?.errors?.min) {
                            <small class="p-error">{{
                                'common.forms.validationMessages.min'
                                    | translate: { min: organizationFormGroup.get('fte')?.errors?.min?.min }
                            }}</small>
                        }
                    }
                </div>
                @if (isOnboarding) {
                    <div class="form-field">
                        <label for="refYearInput" class="form-field__label form-field__label--required">
                            {{ 'components.settingsForm.companySection.firstMeasureYear.label' | translate }}
                        </label>
                        <p-select
                            inputId="refYearInput"
                            [options]="firstYears"
                            formControlName="refYear"
                            [placeholder]="
                                'components.settingsForm.companySection.firstMeasureYear.placeholder' | translate
                            "
                            [emptyFilterMessage]="'common.filter.empty' | translate">
                            <ng-template let-sy pTemplate="selectedItem">
                                <div class="truncate-text">{{ sy }}</div>
                            </ng-template>
                            <ng-template let-year pTemplate="item">
                                <div>{{ year }}</div>
                            </ng-template>
                        </p-select>
                        @if (
                            organizationFormGroup.get('refYear')?.errors?.required &&
                            organizationFormGroup.get('refYear')?.touched
                        ) {
                            <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
                        }
                    </div>
                }
            </div>
        }
        <h2 class="section-title">{{ 'components.settingsForm.userSection.title' | translate }}</h2>
        <div class="form-grid form-grid--2" [class.card]="!isOnboarding" formGroupName="userGroup">
            <div class="form-field">
                <label for="lastnameInput" class="form-field__label form-field__label--required">
                    {{ 'components.settingsForm.userSection.lastname.label' | translate }}
                </label>
                <input
                    id="lastnameInput"
                    pInputText
                    type="text"
                    formControlName="lastname"
                    [placeholder]="'components.settingsForm.userSection.lastname.placeholder' | translate" />
                @if (userFormGroup.get('lastname')?.errors?.required && userFormGroup.get('lastname')?.touched) {
                    <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
                }
            </div>
            <div class="form-field">
                <label for="firstnameInput" class="form-field__label form-field__label--required">
                    {{ 'components.settingsForm.userSection.firstname.label' | translate }}
                </label>
                <input
                    id="firstnameInput"
                    pInputText
                    type="text"
                    formControlName="firstname"
                    [placeholder]="'components.settingsForm.userSection.firstname.placeholder' | translate" />
                @if (userFormGroup.get('firstname')?.errors?.required && userFormGroup.get('firstname')?.touched) {
                    <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
                }
            </div>
            <div class="form-field">
                <label for="roleInput" class="form-field__label">
                    {{ 'components.settingsForm.userSection.role.label' | translate }}
                </label>
                <input
                    id="roleInput"
                    pInputText
                    type="text"
                    formControlName="role"
                    [placeholder]="'components.settingsForm.userSection.role.placeholder' | translate" />
            </div>
            <div class="form-field">
                <label for="emailInput" class="form-field__label form-field__label--required">
                    {{ 'components.settingsForm.userSection.email.label' | translate }}
                </label>
                <input
                    id="emailInput"
                    pInputText
                    type="text"
                    formControlName="email"
                    [placeholder]="'components.settingsForm.userSection.email.placeholder' | translate" />
                @if (userFormGroup.get('email')?.errors?.required && userFormGroup.get('email')?.touched) {
                    <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
                }
            </div>
            <div class="form-field">
                <label for="phoneNumberInput" class="form-field__label form-field__label--required">
                    {{ 'components.settingsForm.userSection.phoneNumber.label' | translate }}
                </label>
                <input
                    id="phoneNumberInput"
                    pInputText
                    type="text"
                    formControlName="phoneNumber"
                    [placeholder]="'components.settingsForm.userSection.phoneNumber.placeholder' | translate" />
                @if (userFormGroup.get('phoneNumber')?.errors?.required && userFormGroup.get('phoneNumber')?.touched) {
                    <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
                }
                @if (userFormGroup.get('phoneNumber')?.errors?.invalidPn && userFormGroup.get('phoneNumber')?.touched) {
                    <small class="p-error">{{
                        'components.settingsForm.userSection.phoneNumber.validation.invalid' | translate
                    }}</small>
                }
            </div>
        </div>
        @if (!isOnboarding) {
            <h2 class="section-title">{{ 'components.settingsForm.securitySection.title' | translate }}</h2>
            <div class="card form-grid form-grid--2" formGroupName="securityGroup">
                <div class="form-field">
                    <label for="oldPasswordInput" class="form-field__label form-field__label--required">
                        {{ 'components.settingsForm.securitySection.oldPassword.label' | translate }}
                    </label>
                    <p-iconfield>
                        <p-inputicon styleClass="ms ms-key" />
                        <input
                            id="oldPasswordInput"
                            type="password"
                            formControlName="oldPassword"
                            autocomplete="off"
                            pInputText
                            [placeholder]="
                                'components.settingsForm.securitySection.oldPassword.placeholder' | translate
                            " />
                    </p-iconfield>
                    @if (
                        securityFormGroup.get('oldPassword')?.errors?.required &&
                        securityFormGroup.get('oldPassword')?.touched
                    ) {
                        <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
                    }
                </div>
                <!-- Keeps the new password and its confirmation on the next row. -->
                <div class="hidden md:block" aria-hidden="true"></div>
                <div class="form-field">
                    <label for="newPasswordInput" class="form-field__label form-field__label--required">
                        {{ 'components.settingsForm.securitySection.newPassword.label' | translate }}
                    </label>
                    <p-iconfield>
                        <p-inputicon styleClass="ms ms-key" />
                        <input
                            id="newPasswordInput"
                            type="password"
                            formControlName="newPassword"
                            autocomplete="new-password"
                            pInputText
                            [placeholder]="
                                'components.settingsForm.securitySection.newPassword.placeholder' | translate
                            " />
                    </p-iconfield>
                    @if (
                        securityFormGroup.get('newPassword')?.errors?.required &&
                        securityFormGroup.get('newPassword')?.touched
                    ) {
                        <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
                    }
                    @if (securityFormGroup.errors?.mustNotMatch && securityFormGroup.get('newPassword')?.touched) {
                        <small class="p-error">{{
                            'components.settingsForm.securitySection.newPassword.mustNotMatch' | translate
                        }}</small>
                    }
                    @if (
                        securityFormGroup.get('newPassword')?.errors?.invalidPassword &&
                        securityFormGroup.get('newPassword')?.touched
                    ) {
                        <small
                            class="p-error"
                            [innerHtml]="
                                'components.settingsForm.securitySection.newPassword.invalidPassword' | translate
                            "></small>
                    }
                </div>
                <div class="form-field">
                    <label for="confirmPasswordInput" class="form-field__label form-field__label--required">
                        {{ 'components.settingsForm.securitySection.confirmPassword.label' | translate }}
                    </label>
                    <p-iconfield>
                        <p-inputicon styleClass="ms ms-key" />
                        <input
                            id="confirmPasswordInput"
                            type="password"
                            formControlName="confirmPassword"
                            autocomplete="new-password"
                            pInputText
                            [placeholder]="
                                'components.settingsForm.securitySection.confirmPassword.placeholder' | translate
                            " />
                    </p-iconfield>
                    @if (
                        securityFormGroup.get('confirmPassword')?.errors?.required &&
                        securityFormGroup.get('confirmPassword')?.touched
                    ) {
                        <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
                    }
                    @if (securityFormGroup.errors?.mustMatch && securityFormGroup.get('confirmPassword')?.touched) {
                        <small class="p-error">{{
                            'components.settingsForm.securitySection.confirmPassword.mustMatch' | translate
                        }}</small>
                    }
                </div>
            </div>
        }
    </div>
    <div class="form-actions">
        <!-- Disabled only while there is nothing to save: an invalid section shows its errors on submit. -->
        <p-button
            type="submit"
            [label]="
                (isOnboarding ? 'components.settingsForm.button.onboarding' : 'components.settingsForm.button.settings')
                    | translate
            "
            [loading]="loading"
            [disabled]="!hasChanges()" />
    </div>
</form>
